import { render, staticRenderFns } from "./ShareRedirect.vue?vue&type=template&id=4649eeda"
import script from "./ShareRedirect.vue?vue&type=script&lang=js"
export * from "./ShareRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports